<template>
  <el-dialog
    width="35%"
    :title="!dataForm.userId ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmit()"
      label-width="90px"
      :rules="dataRule"
    >
      <el-form-item label="姓名" prop="realName">
        <el-input v-model="dataForm.realName" placeholder="请输入员工姓名" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="username">
        <el-input v-model="dataForm.username" placeholder="请输入员工账号" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="所属团队" prop="teamId">
        <el-select v-model="dataForm.teamId" placeholder="请选择" style="width:100%;" clearable @change="selectTeam()">
          <el-option
            v-for="item in teamList"
            :key="item.teamId"
            :label="item.teamName"
            :value="item.teamId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="所属区域" prop="districtId">
        <el-select v-model="dataForm.districtId" placeholder="请选择" style="width:100%;" @change="selectItem">
          <el-option
            v-for="item in areaList"
            :key="item.districtId"
            :label="item.districtName"
            :value="item.districtId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属店铺" prop="storeId">
        <el-select v-model="dataForm.storeId" placeholder="请选择" style="width:100%;">
          <el-option
            v-for="item in selectStore"
            :key="item.storeId"
            :label="item.storeName"
            :value="item.storeId"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="所属工种" prop="professionId">
        <el-select v-model="dataForm.professionId" placeholder="请选择" style="width:100%;" clearable>
          <el-option
            v-for="item in typeList"
            :key="item.professionId"
            :label="item.professionName"
            :value="item.professionId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属岗位" prop="roleId">
        <el-select v-model="dataForm.roleId" placeholder="请选择" style="width:100%;" clearable>
          <el-option
            v-for="item in roleList"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label prop="companyCode" label-width="88px" v-if="show">
        <el-checkbox v-model="dataForm.isLeader">担任组长</el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { userInfoData,userInfo } from '../api';
import { roleListData } from '@/api/list';
export default {
  props: {
    areaList:{
      type: Array,
      default: []
    },
    storeList:{
      type: Array,
      default: []
    },
    teamList:{
      type: Array,
      default: []
    },
    typeList:{
      type: Array,
      default: []
    },
    showType:{
      type: Boolean,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        districtId: "",
        districtName: "",
        teamId: "",
        teamName: "",
        professionId: "",
        professionName: "",
        realName: "",
        username: "",
        isLeader: false,
        storeId: "",
        storeName: "",
        roleId: "",
        userId: ""
      },
      show: false,//显示组长
      roleList:[],
      selectStore: [],
      dataRule: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        // storeId: [
        //   { required: true, message: '请选择店铺', trigger: 'blur' }
        // ],
        // districtId: [
        //   { required: true, message: '请选择地区', trigger: 'blur' }
        // ],
        roleId: [
          { required: true, message: '请选择岗位', trigger: 'blur' }
        ],
        professionId: [
          { required: true, message: '请选择工种', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    init(id) {
      this.dataForm.userId = id || '';
      this.visible = true;
      this.dataForm.isLeader = '';
      this.show = false;
      this.getRoleList();
      userInfoData(this.dataForm.userId).then(data => {
        if (data && data.code === 0) {
          // this.dataForm.districtId = data.user.districtId == 0?'':data.user.districtId;
          // this.dataForm.districtName = data.user.districtName;
          // this.dataForm.storeId = data.user.storeId;
          // this.dataForm.storeName = data.user.storeName;
          this.dataForm.professionId = data.user.professionId;
          this.dataForm.realName = data.user.realName;
          this.dataForm.isLeader = data.user.isLeader == 'Y'?true:false;
          this.dataForm.teamId = data.user.teamId== 0?'':data.user.teamId;
          this.dataForm.teamName = data.user.teamName;
          this.dataForm.username = data.user.username;
          this.dataForm.userId = data.user.userId;
          this.dataForm.roleId = data.user.roleId;
          this.selectTeam()
        }else{
          this.$message.error(data.msg);
        }
      });
    },
    // 监听团队值
    selectTeam(){
      if(this.dataForm.teamId){
        this.show = true;
      }else {
        this.show = false;
      }
    },
    // 根据id判断队伍
    whichTeam() {
      this.teamList.forEach(x => {
        if(x.teamId == this.dataForm.teamId){
          this.dataForm.teamName = x.teamName;
        }
      })
    },
    // 根据id判断店铺
    whichStore() {
      this.storeList.forEach(x => {
        if(x.storeId == this.dataForm.storeId){
          this.dataForm.storeName = x.storeName;
        }
      })
    },
    // 根据id判断工种
    whichProfession() {
      this.typeList.forEach(x => {
        if(x.professionId == this.dataForm.professionId){
          this.dataForm.professionName = x.professionName;
        }
      })
    },
    // 根据id判断岗位
    whichRole() {
      this.roleList.forEach(x => {
        if(x.roleId == this.dataForm.roleId){
          this.dataForm.roleName = x.roleName;
        }
      })
    },
    // 获取岗位列表
    getRoleList() {
      roleListData({
          page: 1,
          limit: 10000,
          roleName: null
      }).then( data  => {
        if (data && data.code === 0) {
          this.roleList = data.page.list;
        } else {
          this.roleList = [];
          this.$message.error(data.msg);
        }
      });
    },
    // 地区和店铺关联
    selectItem(event) {
      this.selectStore = [];
      this.dataForm.storeName = '';
      this.dataForm.storeId = '';
      this.storeList.forEach(item => {
        if(item.districtId == event){
          this.dataForm.districtName = item.districtName;
          this.dataForm.districtId = item.districtId
          this.selectStore.push(item);
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.whichTeam();
          // this.whichStore();
          this.whichProfession();
          this.whichRole();
          let user = {
            // districtId: this.dataForm.districtId || undefined,
            // districtName: this.dataForm.districtName,
            // storeId: this.dataForm.storeId,
            // storeName: this.dataForm.storeName,
            professionName: this.dataForm.professionName,
            professionId: this.dataForm.professionId,
            realName: this.dataForm.realName,
            teamName: this.dataForm.teamName,
            teamId: this.dataForm.teamId,
            roleName: this.dataForm.roleName,
            roleId: this.dataForm.roleId,
            isLeader: this.dataForm.isLeader == true?'Y':'N',
            username: this.dataForm.username,
            userId: this.dataForm.userId,
            password: '123456'
          }
          if(this.dataForm.userId) delete user.password;
          userInfo(user).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
  },
};
</script>
